import Dexie from 'dexie';

export const db = new Dexie('pinbike');

db.version(3).stores({
    fetchStatus: "key",
    cities: 'istatId, city',
    users: 'uid, email, username'
});
